import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REP_DETAIL_CONTAINER_ID } from 'ui-deal-management-components-lib/constants/constants';
import ForecastSubmissionPanel from 'ui-deal-management-components-lib/components/submissionPanel/ForecastSubmissionPanel';
import { setSelectedDealIds, setShowSubmissionPanelFromDealTable } from '../../actions/DealsActions';
import { submitForecastFailed } from '../../actions/ForecastActions';
import { getIsUngatedToManualSubmissionOverhaul } from '../../selectors/authSelectors';
import { getProperties } from '../../selectors/properties';
import { getIsAllPipelines, getIsDealStageView, getSelectedForecastType } from '../../selectors/forecastSelectors';
import { getPipelineFilter, getTimePeriodFilter } from '../../selectors/filtersSelectors';
import { getSelectedDealAmount, getSelectedDealIds, getShowSubmissionPanelFromDealTable } from '../../selectors/dealsSelectors';
import { getIsOverviewDataFetching } from '../../selectors/overviewSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const RepDetailForecastSubmissionPanelWrapper = ({
  handleTrack,
  onSubmitSuccess,
  ownerId,
  teamId
}) => {
  const dispatch = useDispatch();
  const isUngatedForManualSubmissionOverhaul = useSelector(getIsUngatedToManualSubmissionOverhaul);
  const showForecastSubmissionPanel = useSelector(getShowSubmissionPanelFromDealTable);
  const selectedDealAmount = useSelector(getSelectedDealAmount);
  const selectedDealIds = useSelector(getSelectedDealIds);
  const properties = useSelector(getProperties);
  const selectedForecastType = useSelector(getSelectedForecastType);
  const isAllPipelines = useSelector(getIsAllPipelines);
  const pipelines = useSelector(getPipelineFilter);
  const timePeriod = useSelector(getTimePeriodFilter);
  const isDealStageView = useSelector(getIsDealStageView);
  const isOverviewDataFetching = useSelector(getIsOverviewDataFetching);

  // const prevForecastedDeals = useRef(selectedDealIds);

  const resetForecastedDealsToPrevious = useCallback(() => {
    // Temporary solution for Manual Submission Part 1 - always clear checkboxes on close
    dispatch(setSelectedDealIds([]));
  }, [dispatch]);
  const handleSubmitFailure = useCallback(errorType => {
    if (isUngatedForManualSubmissionOverhaul) {
      resetForecastedDealsToPrevious();
    }
    dispatch(submitForecastFailed(errorType));
  }, [dispatch, isUngatedForManualSubmissionOverhaul, resetForecastedDealsToPrevious]);
  const handleSubmitSuccess = useCallback(props => {
    onSubmitSuccess(props);
    // Temporary solution for Manual Submission Part 1 - clear checkboxes on save
    if (isUngatedForManualSubmissionOverhaul) {
      resetForecastedDealsToPrevious();
    }
    dispatch(setShowSubmissionPanelFromDealTable(false));
  }, [dispatch, onSubmitSuccess, isUngatedForManualSubmissionOverhaul, resetForecastedDealsToPrevious]);
  const handleClose = useCallback(() => {
    dispatch(setShowSubmissionPanelFromDealTable(false));
    if (!isUngatedForManualSubmissionOverhaul) {
      return;
    }
    resetForecastedDealsToPrevious();
  }, [dispatch, isUngatedForManualSubmissionOverhaul, resetForecastedDealsToPrevious]);
  if (!showForecastSubmissionPanel || isOverviewDataFetching) {
    return null;
  }
  return /*#__PURE__*/_jsx(ForecastSubmissionPanel, {
    containerId: REP_DETAIL_CONTAINER_ID,
    dealProperties: properties
    // TODO: Remove the cast once Forecasting:MultipleOutcomes is ungated to all
    ,
    forecastType: selectedForecastType,
    forecastAmount: isUngatedForManualSubmissionOverhaul ? undefined : selectedDealAmount,
    dealIds: isUngatedForManualSubmissionOverhaul ? selectedDealIds : undefined,
    ownerId: ownerId,
    teamId: teamId,
    pipelineId: isAllPipelines ? undefined : pipelines.first(),
    timePeriod: timePeriod,
    isDealStageView: isDealStageView,
    onSubmitSuccess: handleSubmitSuccess,
    onSubmitFailure: handleSubmitFailure,
    onClose: handleClose,
    onTrack: handleTrack
  });
};
export default RepDetailForecastSubmissionPanelWrapper;